import { saveColumnChecked, getColumnChecked } from '@/assets/js/localStorage'
export default {
  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      tableVarity: 'areaReports'
    }
  },
  beforeMount() {
    let localStorageChecked = getColumnChecked(this.tableVarity)
    if (localStorageChecked && localStorageChecked != 'undefined' && JSON.parse(localStorageChecked) instanceof Array) {
      let timer = setInterval(() => {
        if (this.tableColumn && this.tableColumn.length) {
          JSON.parse(localStorageChecked).forEach((column, index) => {
            if (this.tableColumn[index]) {
              this.tableColumn[index].visible = column === 'true' || column === true
            }
          })
          this._checkChange()

          clearInterval(timer)
          timer = null
        }
      }, 50)
    }
  },
  methods: {
    handleCheckAllChange(isTrue) {
      let checkeds = new Array(this.tableColumn.length)
      this.tableColumn.forEach((column, index) => {
        column.visible = checkeds[index] = isTrue
      })
      saveColumnChecked(this.tableVarity, JSON.stringify(checkeds))
      this.isIndeterminate = false
    },
    _checkChange() {
      let checkeds = new Array(this.tableColumn.length)
      let checkedCount = 0
      this.tableColumn.forEach((column, index) => {
        checkeds[index] = column.visible
        if (column.visible === true || column.visible === 'true') {
          checkedCount += 1
        }
      })
      saveColumnChecked(this.tableVarity, JSON.stringify(checkeds))
      this.checkAll = checkedCount === this.tableColumn.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableColumn.length
    }
  }
}
